import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { getSuggestionStyles, getSuggestionContent } from './helpers';

var SuggestionContent = function SuggestionContent(props) {
  var item = props.item,
      selected = props.selected,
      onClick = props.onClick,
      onMouseOver = props.onMouseOver,
      inputType = props.inputType,
      onLinkClick = props.onLinkClick,
      forwardRef = props.forwardRef;
  return /*#__PURE__*/React.createElement("div", _extends({}, mergeStyles.apply(void 0, _toConsumableArray(getSuggestionStyles(item, selected))), {
    onClick: onClick,
    onMouseOver: onMouseOver
  }, {
    //удалил реактовский forwardRef из-за несовместимости версий
    ref: forwardRef
  }), getSuggestionContent(item, inputType, onLinkClick));
};

export var Suggestion = /*#__PURE__*/function (_React$Component) {
  _inherits(Suggestion, _React$Component);

  var _super = _createSuper(Suggestion);

  function Suggestion(props) {
    var _this;

    _classCallCheck(this, Suggestion);

    _this = _super.call(this, props);
    _this.state = {
      hasError: false
    };
    return _this;
  }

  _createClass(Suggestion, [{
    key: "componentDidCatch",
    value: function componentDidCatch() {
      this.setState({
        hasError: true
      }); // TODO: https://cianru.atlassian.net/browse/CD-50613
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return null;
      }

      return /*#__PURE__*/React.createElement(SuggestionContent, this.props);
    }
  }]);

  return Suggestion;
}(React.Component);